<template>
    <div>
     <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "DHCP Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current DHCP config." }}
      </p>
    </div>
        <div class="row">
            <div style="margin: 5px 15px 10px">
                <tabs v-model="defactiveIndex">
                    <pane label="DhcpSnooping">
                        <dhcp-snooping/>
                    </pane>
                    <pane label="DhcpClient">
                        <dhcp-snooping-client/>
                    </pane>

                </tabs>
            </div>
        </div>
    </div>
</template>

<script>
import Pane from "./../components/Pane.vue"
import Tabs from "./../components/Tabs.vue"
import DhcpSnooping from "./../views/Dhcpsnooping.vue"
import DhcpSnoopingClient from "./../views/DhcpsnoopingClient.vue"

import { get, post } from "@/utils/http.js"

export default {
    name: "dhcp",
    components: {
        Pane,
        Tabs,
        DhcpSnooping,
        DhcpSnoopingClient,
    },

    data() {
        return {
            defactiveIndex: 0,
        }
    }

}
</script>